$(document).ready(function () {
    const closeSystemMessage = document.getElementById('closeSystemMessage');
    const systemMessage = document.getElementById('systemMessage');

    if (systemMessage) {
        closeSystemMessage.addEventListener('click', (event) => {
            systemMessage.classList.remove( '!translate-y-0');
        });
    }
});